<h4 style="margin-bottom: 20px;">Atendimentos (CRM)</h4>
<div class="row">
  <div class="col-md-12 card card-contato p-4">
    <div class="row">
      <div class="texto-crm col-md-12">Contato Inicial</div>
      <div class="fa fa-phone-square icon-dashboard-crm icon-atendimento col-md-2"></div>
      <div class="texto-dinhero col-md-12">Previsão - R$90,00</div>
    </div>
  </div>
  <div class="col-md-12 card card-agendado p-4">
    <div class="row">
      <div class="texto-crm col-md-12">Agendado</div>
      <div class="fa fa-calendar-check-o icon-dashboard-crm icon-atendimento col-md-2"></div>
      <div class="texto-dinhero col-md-12">Previsão - R$90,00</div>
    </div>
  </div>
  <div class="col-md-12 card card-aprovacao p-4">
    <div class="row">
      <div class="texto-crm col-md-12">Aprovação</div>
      <div class="fa fa-user-circle icon-dashboard-crm icon-atendimento col-md-2"></div>
      <div class="texto-dinhero col-md-12">Previsão - R$90,00</div>
    </div>
  </div>
  <div class="col-md-12 card card-assinatura p-4">
    <div class="row">
      <div class="texto-crm col-md-12">Assinatura</div>
      <div class="fa fa-pencil-square icon-dashboard-crm icon-atendimento col-md-2"></div>
      <div class="texto-dinhero col-md-12">Previsão - R$90,00</div>
    </div>
  </div>
  <div class="col-md-12 card card-sucesso p-4">
    <div class="row">
      <div class="texto-crm col-md-12">Fechado</div>
      <div class="fa fa-money icon-dashboard-crm icon-atendimento col-md-2"></div>
      <div class="texto-dinhero col-md-12">Previsão - R$90,00</div>
    </div>
  </div>
</div>
